import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import ProfCollaboratorGrid from '../component/ProfCollaboratorGrid';

const ProfCollaboratorPage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Profile-Collaborator</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <ProfCollaboratorGrid />
    </>
  );
};

export default ProfCollaboratorPage;
